import React from 'react';
import styles from './FormField.module.scss';

interface FormGridProps {
  children: React.ReactNode;
}

export function FormGrid({ children }: FormGridProps) {
  return <div className={styles.formGrid}>{children}</div>;
}
